/**
 * Represents the type of an [OrderTipSelection].
 */
export var OrderTipSelectionType;
(function (OrderTipSelectionType) {
    /**
     * Indicates that the tip is based on a percentage of the total order item price.
     */
    OrderTipSelectionType["Percentage"] = "Percentage";
    /**
     * Indicates that the tip is an exact monetary amount.
     */
    OrderTipSelectionType["Amount"] = "Amount";
})(OrderTipSelectionType || (OrderTipSelectionType = {}));
//# sourceMappingURL=order-tip-selection-type.js.map